var productTabs = $(".product-tabs");
var tabsTitles = $(".tabs-titles");
var titleDivs = $(".tabs-titles div");
var tabsContent = $(".tabs-content>div");
var mobileTitleDivs = $(".mobile div");

var url = window.location.toString();
var id = url.split("#tab-")[1];

// pc端交互
tabsTitles.on("click", "div", function (e) {
  var index = $(e.currentTarget).attr("data-index");
  const _width = $(window).width();
  titleDivs.removeClass("active");
  $(e.currentTarget).addClass("active");
  tabsContent.removeClass("fade_in");
  setTimeout(function () {
    tabsContent.removeClass("active");
    tabsContent
      .eq(index - 1)
      .addClass("active")
      .addClass("fade_in");
  }, 300);
  if (_width < 768) {
    const _height = $(".tabs-content")[0].offsetTop;
    const _top = $(tabsTitles)[0].offsetTop;
    if(_height<_top){
        console.log($(".tabs-content").offset().top);
        $('html, body').scrollTop($(".tabs-content").offset().top-113);
    }
  }
});
$(".close").click(function () {
  tabsContent.removeClass("mobile_active");
  document.body.style.height = "auto";
  document.body.style.overflow = "auto";
});
$('.m-tabs-titles-header').click(function (e) {

    $(this).parent().find('.mobile-info').toggleClass('active')
    if($(this).parent().find('.active').length){
        document.querySelector('.m-tabs-titles-header').setAttribute('data-opened',true)
    }else{
        document.querySelector('.m-tabs-titles-header').setAttribute('data-opened',false)
    }
});

$('.m-faq-i-q').click(function (e) {
    $(this).parent().find('.faq-i-a').toggleClass('active')
    if($(this).parent().find('.active').length){
        this.setAttribute('data-faqopen',false)
    }else{
        this.setAttribute('data-opened',true)
    }
});

(function (){
    const _height = $('.site-header-sticky').height();
    $('.product-tabs>.tabs-titles').css('top', _height-2);
})()